<script setup lang="ts">
/** While the workstation's chunk (with the SIP stack) loads. */
import { useI18n } from 'vue-i18n'
import Spinner from '@/ui/Spinner.vue'

const { t } = useI18n()
</script>

<template>
  <div class="grid h-full place-items-center"><Spinner :label="t('agent.opening')" /></div>
</template>
